module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-green-2bbd0724a1515cb015f209291363cc1d.svg";